<div class="matters-list-dialog">
  <div class="dialog-header">
    <div class="header-text">
      <h2 mat-dialog-title>
        Matters
        @if (data.requestId) {
          -
          <a
            class="header-request-link"
            [routerLink]="['/requests', data.requestId]"
            (click)="close()"
            >Request {{ data.requestId }}</a
          >
        }
      </h2>
    </div>
    <button
      mat-icon-button
      class="close-button"
      tabindex="-1"
      (click)="close()"
    >
      <mat-icon>close</mat-icon>
    </button>
  </div>

  <mat-dialog-content>
    @for (matter of data.matters; track matter.clientMatterNumber) {
      <div class="matter-row">
        <div class="matter-header">
          <app-matter-cell
            class="matter-info"
            [matterNumber]="matter.clientMatterNumber"
            [matterName]="matter.matterName"
            [clientName]="matter.clientName"
            [link]="true"
            (clicked)="navigateToMatter($event)"
          />
          <div class="matter-actions">
            <button
              mat-icon-button
              class="action-btn"
              matTooltip="View matter details"
              (click)="navigateToMatter(matter.clientMatterNumber)"
            >
              <mat-icon>visibility</mat-icon>
            </button>
            <button
              mat-icon-button
              class="action-btn"
              matTooltip="Open in floating window"
              (click)="openMatterInFloatingDialog(matter)"
            >
              <mat-icon>select_window_2</mat-icon>
            </button>
          </div>
        </div>

        <div class="matter-resources">
          @let count = matter.resources?.length ?? 0;
          @let isExpanded = expandedMatters.has(matter.clientMatterNumber);
          <button
            type="button"
            class="matter-resources-toggle"
            (click)="toggleResources(matter.clientMatterNumber)"
          >
            <mat-icon class="toggle-icon" [class.expanded]="isExpanded"
              >expand_more</mat-icon
            >
            <span class="matter-resources-label"
              >Assigned resources ({{ count }})</span
            >
          </button>
          @if (isExpanded) {
            @if (count > 0) {
              <ul class="matter-resources-list">
                @for (name of matter.resources!; track name) {
                  <li>{{ name }}</li>
                }
              </ul>
            } @else {
              <span class="matter-resources-empty">None assigned</span>
            }
          }
        </div>
      </div>
    }
  </mat-dialog-content>
</div>
